export default class Pedagogic {
  static getPageContent() {
    if (window?.API?.['fake-news-pedagogic']) {
      return window.API['fake-news-pedagogic'];
    }
    return {
      title: 'À qui se fier ?',
      infox: {
        title: 'LE PROJET INFOX',
        text: '<p>Lorem ipsum dolor&nbsp;sit amet, consectetur adipiscing elit. Duis ipsum diam, lacinia at auctor sed, ullamcorper a ipsum. Morbi luctus urna at nulla pellentesque, quis dignissim metus tempor. Morbi eget mauris orci. Nam dolor mauris, efficitur at lorem id, interdum dapibus purus. In hac habitasse platea dictumst.&nbsp;</p>\r\n',
        links: {
          0: {
            uri: 'internal:/',
            title: 'Les coulisses',
            options: [],
          },
          1: {
            uri: 'internal:/',
            title: 'La charte',
            options: [],
          },
          3: {
            uri: 'internal:/',
            title: 'Méthodologie',
            options: [],
          },
        },
        image: '',
      },
      decoding: {
        nodes: {
          96: {
            title: 'La structure du VIH et son cycle de réplication',
            thumbnail: 0,
            link: '/la-structure-du-vih-et-son-cycle-de-replication',
            category: 0,
            sub_category: 0,
          },
          118: {
            title: 'Prévention ou éducation sexuelle : quelles différences ?',
            thumbnail: 0,
            link: '/prevention-ou-education-sexuelle-quelles-differences',
            category: 0,
            sub_category: 0,
          },
          4779830: {
            title: 'Essai fake news decrypt',
            thumbnail: 0,
            link: '/essai-fake-news-decrypt',
            category: 'Cancers',
            sub_category: 0,
          },
        },
      },
      dictionnary: {
        wordings: {
          title_fakenews_main: 'Bienvenue dans le service',
          subtitle_fakenews_main: '“fake news” de Santé.fr',
          btn_decryptage: 'Accéder aux décryptages',
          btn_pedagogie: 'Voir toute la rubrique',
          title_pedagogie: 'À qui se fier ?',
          title_decryptage_article: 'Sur le même thème',
          title_pedagogie_article: 'Dans la même rubrique',
          title_fakenews_decryptage: 'La rubrique décryptage',
          menu_main: 'Accueil Fake News',
          menu_decryptage: 'Décryptage Fake News',
          menu_pedagogie: 'A qui se fier ? Fake News',
        },
      },
    };
  }
}
